import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMediumKodemScore = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.25 10.7129C2.25017 10.6246 2.32284 10.5527 2.41113 10.5527L15.5889 10.5527C15.6772 10.5527 15.7498 10.6246 15.75 10.7129L15.75 11.999C15.7499 12.0874 15.6772 12.1592 15.5889 12.1592L2.41113 12.1592C2.32278 12.1592 2.25006 12.0874 2.25 11.999L2.25 10.7129ZM2.25 6.60645C2.25015 6.51818 2.32283 6.44629 2.41113 6.44629L15.5889 6.44629C15.6772 6.44629 15.7498 6.51818 15.75 6.60644L15.75 7.89258C15.7499 7.98091 15.6772 8.05273 15.5889 8.05273L2.41113 8.05273C2.32278 8.05273 2.25007 7.98091 2.25 7.89258L2.25 6.60645Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgMediumKodemScore);
export { ForwardRef as ReactComponent };
